import { render, staticRenderFns } from "./NewEditable.vue?vue&type=template&id=1b4c6bd2&scoped=true&"
import script from "./NewEditable.vue?vue&type=script&lang=ts&"
export * from "./NewEditable.vue?vue&type=script&lang=ts&"
import style0 from "./NewEditable.vue?vue&type=style&index=0&id=1b4c6bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c6bd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VIcon,VProgressCircular,VTextField,VTextarea})
